module.exports = __webpack_public_path__ + "static/media/butter.03d8e9cc.png";